import Vue from 'vue'
import { IComponentData } from '../../store/editor/components/state'

interface Mapping {
  [type: string]: typeof Vue
}

export default class PreviewVueFactory {
  static mapping: Mapping = {}
  static frozen: boolean = false

  static register(type: string, component: typeof Vue): void {
    if (!this.frozen) {
      PreviewVueFactory.mapping[type] = component
    }
  }

  static freeze(): void {
    this.frozen = true
  }

  static get(component: IComponentData): typeof Vue {
    const found = PreviewVueFactory.mapping[component.type]
    if (found) {
      return found
    }
    throw new Error('コンポーネントが見つかりません: type=' + component.type)
  }
}
